/** Rubrique Scanner (entrée / sortie) : réglages du flux de scan des étiquettes. */
import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { metaApi, parametresApi } from '../../../services/api';
import { Button, Spinner, Card } from '../../../components/ui/kit';

export default function ScannerSettings() {
  const [est, setEst] = useState(null);
  useEffect(() => { metaApi.settings().then(setEst); }, []);
  if (!est) return <Spinner />;

  const set = (k, v) => setEst({ ...est, [k]: v });
  const save = async () => {
    await parametresApi.updateEstablishment({ back_label_autostart: !!est.back_label_autostart });
    toast.success('Réglages du scanner enregistrés');
  };

  return (
    <div className="max-w-[640px]">
      <h2 className="font-title text-3xl mb-1">Scanner entrée-sortie</h2>
      <p className="text-[13px] text-n600 mb-5">Réglages du flux de scan des étiquettes (entrées et sorties de stock).</p>
      <Card className="p-5 space-y-4">
        <label className="flex items-center gap-3 cursor-pointer" data-testid="def-back-autostart">
          <input type="checkbox" className="accent-[#b68235] w-4 h-4" checked={!!est.back_label_autostart} onChange={(e) => set('back_label_autostart', e.target.checked)} />
          <span><span className="text-[14px]">Démarrer automatiquement la contre-étiquette</span><span className="block text-[12px] text-n500">Après la photo de l'étiquette, la capture de la contre-étiquette démarre sans clic.</span></span>
        </label>
        <Button variant="primary" onClick={save} data-testid="scanner-save">Enregistrer</Button>
      </Card>
    </div>
  );
}
